import Controller from '../controller/Controller';

export default class BG extends Phaser.GameObjects.Container {
    private sprite!: Phaser.GameObjects.Image;
    private gradient!: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene) {
        super(scene, 0, 0);
        this.scene.layers.bg.add(this);

        // this.setupSprite();
        this.setupGradient();
        this.setupListeners();
    }

    setupSprite(frame: string) {
        if (this.sprite) this.sprite.destroy();

        let width = this.scene.cameras.main.width;
        let height = this.scene.cameras.main.height;
        let x = this.scene.cameras.main.centerX;
        let y = this.scene.cameras.main.centerY - 260;

        // this.sprite = this.scene.add.image(x, y, 'atlas', frame);
        this.sprite = this.scene.add.image(x, y, frame);
        this.sprite.setDisplaySize(width, height);
        this.add(this.sprite);

        // this.sprite.setVisible(false);
    }

    setupGradient() {
        let frame = 'bg/top_gradient';
        let width = this.scene.cameras.main.width;

        this.gradient = this.scene.add.image(0, 0, 'atlas', frame);
        this.gradient.setOrigin(0);
        this.gradient.displayWidth = width;
        this.add(this.gradient);
    }

    setupListeners() {
        this.scene.events.on(Controller.EVENTS.NEW_CHAPTER_STARTED, this.onNewChapter, this);
    }

    onNewChapter(background: string): void {
        this.setupSprite(background);
    }

    destroy() {
        this.scene.events.off(Controller.EVENTS.NEW_CHAPTER_STARTED, this.onNewChapter, this);
        super.destroy();
    }
}
